import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-5"><path d="M21.25 4C21.6642 4 22 4.33579 22 4.75V8.5H16.75C15.5074 8.5 14.5 9.50736 14.5 10.75V13.25C14.5 14.4926 15.5074 15.5 16.75 15.5H22V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75C2 4.33579 2.33579 4 2.75 4H21.25Z" fill="currentColor"/><path d="M16 10.75C16 10.3358 16.3358 10 16.75 10H22.25C22.6642 10 23 10.3358 23 10.75V13.25C23 13.6642 22.6642 14 22.25 14H16.75C16.3358 14 16 13.6642 16 13.25V10.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconWallet5;
